<template>
  <router-view/>
</template>
<script setup>

</script>
<style>
body {
  font-weight: 500;
}
.btn {
  box-shadow: 3.2534358501434326px 3.2534358501434326px 0px 0px rgba(13, 105, 56, 1);
  position: relative;

}
.btn--loading {
  pointer-events: none;
}
.btn--loading > span {
    visibility: hidden;
  }
.btn--loading:before {
    margin: -13px 0 0 -13px;
    width: 24px;
    height: 24px;
    position: absolute;
    left: 50%;
    top: 50%;
    content: '';
    background-clip: padding-box;
    border-radius: 24px;
    background-clip: padding-box;
    border: rgba(255, 255, 255, 0.5) 2px solid;
    border-top-color: #000;
    animation: animation-rotate 750ms linear infinite;
}
/* animation */
@keyframes animation-rotate {
	100% {
		transform: rotate(360deg);
	}
}

.transition {
	transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

</style>
